.page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
}

.header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
}

.subtitle {
  margin: 0;
  color: rgba(255, 255, 255, 0.65);
  font-size: 13px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 16px;
  align-items: start;
}

.panel {
  background: var(--surface-color, #15171b);
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 280px;
}

.panelHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.panelTitle {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.7);
}

.panelCount {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.empty,
.error,
.loading {
  color: rgba(255, 255, 255, 0.55);
  font-size: 13px;
  padding: 12px 0;
}

.error {
  color: #ff8888;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.table th,
.table td {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.9);
  vertical-align: top;
}

.table th {
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.55);
}

.taskName {
  color: #ffffff;
  font-weight: 500;
}

.taskMeta {
  color: rgba(255, 255, 255, 0.55);
  font-size: 12px;
  margin-top: 2px;
}

.eventList,
.commentList {
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.event,
.comment {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.eventTime {
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  letter-spacing: 0.04em;
}

.eventTitle {
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
}

.eventMeta {
  color: rgba(255, 255, 255, 0.55);
  font-size: 12px;
}

.eventLink {
  color: #6ec8ff;
  font-size: 12px;
  text-decoration: none;
}

.eventLink:hover {
  text-decoration: underline;
}

.commentHead {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.commentBody {
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  line-height: 1.4;
}

.commentLink {
  color: #6ec8ff;
  font-size: 12px;
  text-decoration: none;
}

.commentLink:hover {
  text-decoration: underline;
}
